import type { SolutionGasRsoCalculator } from "../../d";

export const solutionGasRsoCalculator: SolutionGasRsoCalculator = params => {
  const {
    gasSpecificGravity,
    oilAPI,
    surfaceTemperatureF,
    tubingPressurePSIA,
    temperatureInRankine,
    reservoirPressurePSIA,
    inSituPressurePSIA,
    gasOilRatio
  } = params;
  // D228: D8*(1+0.5912*D7*D6*LOG10(D5/114.7)*10^-4)
  let gasSGatSeparatorYgPsp = gasSpecificGravity;
  if (tubingPressurePSIA) {
    gasSGatSeparatorYgPsp =
      gasSpecificGravity *
      (1 +
        0.5912 *
          oilAPI *
          surfaceTemperatureF *
          Math.log10(tubingPressurePSIA / 114.7) *
          10 ** -4);
  }
  // D230: =D228*(1+0.1595*(D7^0.4078)*(D6^-0.2466)*LOG10(D5/114.7))
  let gasSGat100psigSeparatorYg100 = gasSpecificGravity;
  if (tubingPressurePSIA) {
    gasSGat100psigSeparatorYg100 =
      gasSGatSeparatorYgPsp *
      (1 +
        0.1595 *
          oilAPI ** 0.4078 *
          surfaceTemperatureF ** -0.2466 *
          Math.log10(tubingPressurePSIA / 114.7));
  }
  // D232: =(13.1405*D7)/D15
  const xLtApi30 = (13.1405 * oilAPI) / temperatureInRankine;
  // D234: =10^D232
  const cnLtApi30 = 10 ** xLtApi30;
  // D238: =(11.2895*D7)/D15
  const xGtApi30 = (11.2895 * oilAPI) / temperatureInRankine;
  // D240: =10^D238
  const cnGtApi30 = 10 ** xGtApi30;

  // SOLUTION GAS IN-SITU
  // D236: =0.05958*D234*(D230^0.7972)*(D3^1.0014)
  const solutionGasAPILte30RsoInSitu =
    0.05958 *
    cnLtApi30 *
    gasSGat100psigSeparatorYg100 ** 0.7972 *
    inSituPressurePSIA ** 1.0014;
  // D242: =0.0315*D240*(D230^0.7587)*(D3^1.0937)
  const solutionGasAPIGt30RsoInSitu =
    0.0315 *
    cnGtApi30 *
    gasSGat100psigSeparatorYg100 ** 0.7587 *
    inSituPressurePSIA ** 1.0937;
  // D244: =IF(D7>30,D242,D236)
  const solutionGasRsoInSitu =
    oilAPI > 30 ? solutionGasAPIGt30RsoInSitu : solutionGasAPILte30RsoInSitu;

  // SOLUTION GAS AT RESERVOIR
  // D254: =0.05958*D252*(D248^0.7972)*(D12^1.0014)
  const solutionGasAPILte30RsoAtReservoir =
    0.05958 *
    cnLtApi30 *
    gasSGat100psigSeparatorYg100 ** 0.7972 *
    reservoirPressurePSIA ** 1.0014;
  // D260: =0.0315*D258*(D248^0.7587)*(D12^1.0937)
  const solutionGasAPIGt30RsoAtReservoir =
    0.0315 *
    cnGtApi30 *
    gasSGat100psigSeparatorYg100 ** 0.7587 *
    reservoirPressurePSIA ** 1.0937;
  // D244: =IF(D25>30,D260,D254)
  const solutionGasRsoAtReservoir =
    oilAPI > 30
      ? solutionGasAPIGt30RsoAtReservoir
      : solutionGasAPILte30RsoAtReservoir;

  return {
    gasSGatSeparatorYgPsp,
    gasSGat100psigSeparatorYg100,
    xLtApi30,
    cnLtApi30,
    solutionGasAPI30Rso: solutionGasAPILte30RsoInSitu,
    xGtApi30,
    cnGtApi30,
    solutionGasRsoAtReservoir:
      solutionGasRsoAtReservoir > gasOilRatio
        ? gasOilRatio
        : solutionGasRsoAtReservoir,
    solutionGasRsoInSitu:
      solutionGasRsoInSitu > gasOilRatio ? gasOilRatio : solutionGasRsoInSitu
  };
};
